import { NotificationVariation } from '@salecycle/ui-component-library';
import { createContext, Dispatch, FC, ReactNode, useContext, useReducer } from 'react';
import notificationsReducer, { IAction } from './notificationsReducer';

export interface INotificationsContext {
  delay: number;
  text: string;
  detailsText: string | ReactNode;
  variation: NotificationVariation;
  visible: boolean;
}

export type IDispatch = Dispatch<IAction>;

const NotificationsStateContext = createContext<INotificationsContext | undefined>(undefined);
const NotificationsDispatchContext = createContext<IDispatch | undefined>(undefined);

export const NotificationsProvider: FC = ({ children }) => {
  const [state, dispatch] = useReducer(notificationsReducer, {
    delay: 5000,
    visible: false,
    variation: 'normal',
    text: '',
    detailsText: '',
  });

  return (
    <NotificationsStateContext.Provider value={state}>
      <NotificationsDispatchContext.Provider value={dispatch}>{children}</NotificationsDispatchContext.Provider>
    </NotificationsStateContext.Provider>
  );
};

export function useNotificationsState() {
  const context = useContext(NotificationsStateContext);

  if (context === undefined) {
    throw new Error('useNotificationsState must be used within a NotificationsProvider');
  }
  return context;
}

export function useNotificationsDispatch() {
  const context = useContext(NotificationsDispatchContext);

  if (context === undefined) {
    throw new Error('useNotificationsDispatch must be used within a NotificationsProvider');
  }
  return context;
}

export const _showNotification = (
  dispatch: IDispatch,
  text: INotificationsContext['text'],
  detailsText: INotificationsContext['detailsText'],
  variation: INotificationsContext['variation'] = 'normal',
  delay: INotificationsContext['delay'] = 5000,
) => {
  dispatch({
    type: 'showNotification',
    payload: {
      delay,
      text,
      detailsText,
      variation,
    },
  });
};

export const _closeNotification = (dispatch: IDispatch) => {
  dispatch({
    type: 'closeNotification',
  });
};
